class productBenefitAccordion {
  constructor(parent) {
    if (!parent) {
      return;
    }

    this.parent = parent;
    this.init();
  }

  clickEvent = () => {
    const items = document.querySelectorAll('.benefit-accordion-item');

    items.forEach((item, index) => {
      const button = item.querySelector('.benefit-accordion-item-heading');
      const content = item.querySelector('.benefit-accordion-item-content');

      // Set the first item to be open by default
      if (index === 0) {
        item.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }

      button.addEventListener('click', () => {
        if (item.classList.contains('open')) {
          item.classList.remove('open');
          content.style.maxHeight = null;
        } else {
          items.forEach((el) => {
            el.classList.remove('open');
            el.querySelector('.benefit-accordion-item-content').style.maxHeight = null;
          });
          item.classList.add('open');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  }

  init = () => {
    this.clickEvent();
  }
}
new productBenefitAccordion(document.querySelector('.section-benefit-accordion'));